module.exports = {
	"articleTitle1": "Trotter site prompts mixed responses ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Helen Newberry Residence",
	"articleLink1": "https://www.michigandaily.com/section/news/barbour-newberry-residents-voice-concerns-over-new-multicultural-center-location",
	"articleLink2": "https://www.michigandaily.com/section/news/regents-approve-new-multicultural-center-replace-trotter",
	"articleSnippet1": "Jan 6, 2016 ... For several residents of Betsy Barbour and Helen Newberry residence halls, the \nplanned relocation of the Trotter Multicultural Center from its ...",
	"articleSnippet2": "Dec 17, 2015 ... The new facility will be situated on State Street, behind Betsy Barbour and Helen \nNewberry Residence Halls on Central Campus, and will ...",
	"totalMisc": 0,
	"articleTitle2": "Regents approve new multicultural center ",
	"address": "432 S State St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.276936,
		"lng": -83.741564
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/helennewberry.json
// module id = 889
// module chunks = 0